<script setup>
    import { ref, onMounted } from 'vue';
    import axios from 'axios';
    import * as bootstrap from 'bootstrap';
    import VueDatePicker from '@vuepic/vue-datepicker';

    const props = defineProps(['fetchUrl']);



    document.addEventListener('DOMContentLoaded', () => {
        const additionalModalRech = document.querySelector('#createRechnungsempfaenger');

        additionalModalRech.addEventListener('shown.bs.modal', async () => {
            loadName();
        });
    });


    const rechnungsempfaenger = ref({
    resb: '',
    Name1: '',
    Name2: '',
    Anrede: 'Frau',
    Strasse: '',
    PLZ: '',
    Ort: '',
    Land: 'Deutschland',
    Email: '',
    Telefon1: '',
    IBAN: '',
    Geburtsdatum: new Date('1990.01.01'),
    Vertragsbeginn: new Date(),
    Zahlart: 'Überweisung',
    Teilnehmernummer: '',
    Rechnungsempfaengernummer: '',
});

onMounted(() => {
    const additionalModalRech = document.querySelector('#createRechnungsempfaenger');

    if (additionalModalRech) {
        additionalModalRech.addEventListener('shown.bs.modal', async () => {
            await loadName();
        });
    }
});

async function loadName() {
    const rechnungsempfaenger2 = document.querySelector('#rechnungsempfaengernummer').value;
    const teilnehmer = document.querySelector('#teilnehmernummer').value;

    try {
        const response3 = await axios.post("teilnehmer/Name", {
            rechnungsempfaenger: rechnungsempfaenger2,
            teilnehmer: teilnehmer
        });

        rechnungsempfaenger.value.Name1 = response3.data.Name;
        rechnungsempfaenger.value.Name2 = response3.data.Vorname;
    } catch (error) {
        console.error("There was an error!", error);
    }
}


    const submitResult = ref(null);
    const submitError = ref(null);
    const isLoading = ref(null);
    const showInfo = ref(null);

    // Loads a bootstrap modal & saving the new rechnungsempfaenger.
    async function saveRechnungsempfaenger() {
        try {
            isLoading.value = true;
            showInfo.value = true;
            rechnungsempfaenger.value.resb = createRechnungsempfaenger.querySelector('#firmennachzahler').value;
            rechnungsempfaenger.value.Teilnehmernummer = createRechnungsempfaenger.querySelector('#teilnehmernummer').value;
            rechnungsempfaenger.value.Rechnungsempfaengernummer = createRechnungsempfaenger.querySelector('#rechnungsempfaengernummer').value;

            const response2 = await axios.post(props.fetchUrl, rechnungsempfaenger.value);
            submitResult.value = response2;
            setTimeout(() => {
                const currentModalR = document.querySelector('#createRechnungsempfaenger');
                const modal = bootstrap.Modal.getInstance(currentModalR);
                modal.hide();
            },1000);
            setTimeout(() => {
                    window.location.reload();
                }, 1000);

        } catch (error) {
            isLoading.value = false;
            showInfo.value = false;
            submitError.value = error;

            setTimeout(() => {
                submitError.value = null;
            }, 3000);
        }
    }
</script>

<template>
    <form @submit.prevent="submit">
        <div class="row">
            <div class="col-sm-4 mb-2">
                <label for="firmennachzahler">Firmennachzahler</label>
                <input id="firmennachzahler"
                    type="text"
                    class="form-control"
                />
            </div>
            <div class="col-sm-4">
                <label for="anrede">Anrede</label>
                <select id="anrede" v-model="rechnungsempfaenger.Anrede" class="form-select form-control">
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                    <option value="Divers">Divers</option>
                </select>
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Anrede !== 'undefined')" v-html="submitError.response.data.Anrede"></div>
            </div>

            <div class="col-sm-4">
                <label for="name1">Nachname</label>
                <input id="name1"
                    type="text"
                    v-model="rechnungsempfaenger.Name1"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Name1 !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name1 !== 'undefined')" v-html="submitError.response.data.Name1[0]"></div>
             </div>

            <div class="col-sm-4 mb-2">
                <label for="name2">Vorname</label>
                <input id="name2"
                    type="text"
                    v-model="rechnungsempfaenger.Name2"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Name2 !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name2 !== 'undefined')" v-html="submitError.response.data.Name2[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="strasse">Straße</label>
                <input id="strasse"
                    type="text"
                    v-model="rechnungsempfaenger.Strasse"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Strasse !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Strasse !== 'undefined')" v-html="submitError.response.data.Strasse[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="ort">Ort</label>
                <input id="ort"
                    type="text"
                    v-model="rechnungsempfaenger.Ort"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Ort !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Ort !== 'undefined')" v-html="submitError.response.data.Ort[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="plz">Postleitzahl</label>
                <input id="plz"
                    type="text"
                    v-model="rechnungsempfaenger.PLZ"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.PLZ !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.PLZ !== 'undefined')" v-html="submitError.response.data.PLZ[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="land">Land</label>
                <select id="land" v-model="rechnungsempfaenger.Land" class="form-select form-control">
                    <option value="Deutschland">Deutschland</option>
                    <option value="Belgien">Belgien</option>
                    <option value="Niederlande">Niederlande</option>
                    <option value="Luxemburg">Luxemburg</option>
                    <option value="Frankreich">Frankreich</option>
                    <option value="Österreich">Österreich</option>
                    <option value="Schweiz">Schweiz</option>
                    <option value="Italien">Italien</option>
                    <option value="Rumänien">Rumänien</option>
                    <option value="Spanien">Spanien</option>
                </select>
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Land !== 'undefined')" v-html="submitError.response.Land"></div>
            </div>

            <div class="col-sm-4">
                <label for="email">E-Mail</label>
                <input id="email"
                    type="text"
                    v-model="rechnungsempfaenger.Email"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Email !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Email !== 'undefined')" v-html="submitError.response.data.Email[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="telefon1">Telefonnummer</label>
                <input id="telefon1"
                    type="text"
                    v-model="rechnungsempfaenger.Telefon1"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Telefon1 !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Telefon1 !== 'undefined')" v-html="submitError.response.data.Telefon1[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="zahlart">Zahlart</label>
                <select id="zahlart" v-model="rechnungsempfaenger.Zahlart" class="form-select form-control">
                    <option value="Überweisung">Überweisung</option>
                    <option value="SEPA-Basislastschrift (CORE)">IBAN</option>
                </select>

                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Zahlart !== 'undefined')" v-html="submitError.response.data.Zahlart"></div>
            </div>

            <div v-if="rechnungsempfaenger.Zahlart === 'SEPA-Basislastschrift (CORE)'" class="col-sm-4">
                <label for="iban">IBAN</label>
                <input
                    id="iban"
                    type="text"
                    v-model="rechnungsempfaenger.IBAN"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.IBAN !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.IBAN !== 'undefined')" v-html="submitError.response.data.IBAN[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="geburtsdatum">Geburtsdatum</label>
                <VueDatePicker
                    v-model="rechnungsempfaenger.Geburtsdatum"
                    id="geburtsdatum"
                    text-input
                    format="yyyy.MM.dd"
                    locale="de"
                    :enable-time-picker="false"
                    selectText="Auswählen"
                    cancelText="Abbrechen"
                    :class="{
                        'form-control': true,
                        'is-valid': submitResult !== null,
                        'is-invalid': submitError !== null && typeof submitError.response.data.Geburtsdatum !== 'undefined'
                        }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Geburtsdatum !== 'undefined')" v-html="submitError.response.data.Geburtsdatum[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="vertragsbeginn">Vertragsbeginn</label>
                <VueDatePicker
                    id="vertragsbeginn"
                    v-model="rechnungsempfaenger.Vertragsbeginn"
                    text-input
                    format="yyyy.MM.dd"
                    locale="de"
                    :enable-time-picker="false"
                    selectText="Auswählen"
                    cancelText="Abbrechen"
                    :class="{
                        'form-control': true,
                        'is-valid': submitResult !== null,
                        'is-invalid': submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined'
                        }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined')" v-html="submitError.response.data.Vertragsbeginn[0]"></div>
            </div>
            <div class="col-sm-4 mb-2">
                <label for="teilnehmernummer">Teilnehmer</label>
                <input id="teilnehmernummer"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>

            <div class="col-sm-4 mb-2">
                <label for="rechnungsempfaengernummer">Rechnungsempfaengernummer</label>
                <input id="rechnungsempfaengernummer"
                    type="text"
                    class="form-control"
                    readonly
                />
            </div>
        </div>
        <button type="submit" class="btn btn-primary" @click.prevent="saveRechnungsempfaenger()">Rechnungsempfaenger hinzufügen
            <i :class="[isLoading ? 'fa-solid fa-spinner fa-spin' : '']" :disabled="isLoading"></i>
        </button>
        <p v-if="showInfo" class="text-warning">If saving takes too long, check S&B api connection. Await 60s.</p>


    </form>
    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Firmennachzahler erfolgreich bearbeitet.</span>
    </div>
</template>
